<!-- Dialog: QUICK FILL CONFIRM  -->
<p-dialog
  #dialog
  [(visible)]="data.dialogData.show"
  [width]="data.dialogData.width"
  appendTo="body"
  [resizable]="false"
  [closable]="true"
  [modal]="true"
  [draggableDialog]="dialog"
  [styleClass]="data.dialogData.class_name"
  (onHide)="closeDialog()"
>
  <p-header> {{ data.dialogData.title_text }} </p-header>
  <div>
    <p *ngFor="let message of data.dialogData.message_text" fxLayout="row" fxLayoutGap="5px">
      <span fxFlex="40px" fxLayoutAlign="center center" *ngIf="data.dialogData.message_icon_show">
        <i class="fa icon-warning fa-lg" aria-hidden="true"></i>
      </span>
      <span fxFlex>{{ message }}</span>
    </p>

    <p>{{ data.dialogData.message_question }}</p>
  </div>

  <p-footer fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="end center">
    <button
      pButton
      type="button"
      class="bfx-button-secondary-subtle"
      (click)="actionQuickFillWarning_no()"
      label="No"
    ></button>
    <button
      pButton
      type="button"
      class="bfx-button-primary"
      (click)="actionQuickFillWarning_yes()"
      label="Yes"
    ></button>
  </p-footer>
</p-dialog>
